import { inject } from '@angular/core';
import { GroupService } from '../services/group.service';
import { InviteStudentPage } from '../../pages/subjects/subject-teaching/students/invite-student/invite-student.page';

export const inviteStudentDeactivateGuard = async (component: InviteStudentPage) => {
  const groupService = inject(GroupService);

  // CR7 invitation codes remain valid until the midnight expiration job.
  if (component.groupId && !component.isRouteModal) {
    try {
      await groupService.clearGroupJoinCode(component.groupId);
    } catch (error) {
      console.error('Error clearing joinCode on route deactivation:', error);
    }
  }

  return true;
};